import {API_URL, apiGet, apiPost} from '../api'
import {ApiRes} from '../../types/api'

export interface DevServer {
    branch: string
    mongo_port: string
    mysql_port: string
    created_at: string
    updated_at: string
    status: string
}

export const getDevServerApi = async (size: number, current_page: number = 1): Promise<ApiRes<DevServer[]>> => {
    return await apiGet(API_URL, `admin/devs?page_size=${size}&current_page=${current_page}`)
}

export const devServerTerminate = async (branch: string) => {
    return await apiPost(API_URL, `admin/dev/terminate`, {branch: branch})
}
